const captureSentryMessage: (
  message: string,
  options?: {
    tags?: { [key: string]: string | number | null | undefined };
    user?: { originalId?: number | null; username?: string | null };
    extra?: { [key: string]: any };
  },
) => void = (message, options) => {
  if (typeof window !== 'undefined' && window.Sentry) {
    // @ts-expect-error
    window.Sentry.withScope(scope => {
      if (options?.tags) {
        Object.keys(options.tags).forEach(key => {
          scope.setTag(key, options.tags![key]);
        });
      }
      if (options?.extra) {
        Object.keys(options.extra).forEach(key => {
          scope.setExtra(key, options.extra![key]);
        });
      }
      if (options?.user) {
        scope.setUser(options.user);
      }
      window.Sentry.captureMessage(message);
    });
  }
};

export default captureSentryMessage;
